import React from 'react';

import { Nullable } from '@clearverify/types';

import { EmployeeWhere, UserStatus } from 'src/api';
import { useFilterStorage } from 'src/hooks/common';

export function useStatusTableFilter(): {
  filterByUserStatus: EmployeeWhere;
} {
  const { filter } = useFilterStorage();
  const status = filter.status as Nullable<UserStatus[]>;

  const filterByUserStatus = React.useMemo(() => {
    if (!status?.length) return {};

    const employeeFilter: EmployeeWhere = {
      user: {
        status: {
          in: status,
        },
      },
    };

    return employeeFilter;
  }, [status]);

  return {
    filterByUserStatus,
  };
}
